<!--
 * @Description: 运单监控轴线
 * @Author: 2021-06-08 10:50:09
 * @Date: 2020-08-25 15:37:33
 * @LastEditors: fanwenjing
 * @LastEditTime: 2021-06-24 19:19:14
-->
<template>
  <div class="waybill-axis">
    <e6-axis
      :data="localData"
      :width="150"
      :forwardHeight="64"
      :reverseHeight="64"
      :axisHeight="30"
    >
      <div
        class="content"
        slot="forward"
        slot-scope="{ node }"
        :class="[`status--${node.nodeStatus}`]"
      >
        <div class="name">
          <template v-if="nodeIconClass(node) !== '0'">
            <span v-show="node.actualArriveTimeStr"
              >{{ node.actualArriveTimeStr }} 到达</span
            >
            <span
              class="late"
              v-if="node.arriveLateTimeStr"
              :title="'晚点' + node.arriveLateTimeStr"
              >晚</span
            >
          </template>
          <template v-else>
            <span v-show="node.expectArriveTimeStr"
              >预计{{ node.expectArriveTimeStr }} 到达</span
            >
          </template>
        </div>
        <div
          class="temp ellipsis"
          :title="node.stayTimeStr"
          v-show="node.stayTimeStr"
        >
          停留时间 {{ node.stayTimeStr }}
        </div>
        <div class="temp ellipsis" :title="node.temp">
          {{ node.temp }}
        </div>
      </div>

      <div
        class="content"
        slot="reverse"
        slot-scope="{ node }"
        :class="[`status--${node.nodeStatus}`]"
      >
        <div class="name ellipsis" :title="node.waybillNodeName">
          {{ node.waybillNodeName }}
          <span v-if="node.nodeType === 5" class="back-icon">返</span>
        </div>
        <div class="time">
          <template v-if="node.actualLeaveTimeStr">
            <span>{{ node.actualLeaveTimeStr }} 离开 </span>
            <span
              class="late"
              v-if="node.leaveLateTimeStr"
              :title="'晚点' + node.leaveLateTimeStr"
              >晚</span
            >
          </template>
        </div>
      </div>

      <template slot="axis" slot-scope="{ node }">
        <div class="line"></div>
        <div
          v-if="
            [
              'icon--2',
              'icon--2x',
              'icon--2a',
              'icon--2ax',
              'icon--4',
              'icon--4a'
            ].includes(node.class)
          "
          class="line line-2"
        ></div>
        <node-icon :data="node"></node-icon>
        <span
          class="line-top"
          v-show="
            node.id !== localData[localData.length - 1].id && node.nodeMileage
          "
          >{{ node.nodeMileage }}km</span
        >
      </template>
    </e6-axis>
  </div>
</template>

<script>
import NodeIcon from "e6-base-carrier-3.0/components/packages/WaybillAxis/node-icon";

export default {
  name: "WaybillAxis",

  componens: { NodeIcon },

  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  data() {
    return {
      localData: []
    };
  },

  watch: {
    data: {
      immediate: true,
      handler: function() {
        this.formartData();
      }
    }
  },

  methods: {
    nodeIconClass(node) {
      let type; // 默认对勾

      const status = node.nodeStatus; // 0,1,2,3,4

      const abnNode = Array.isArray(node.pointAlarm) && node.pointAlarm.length; // a 节点上
      const abnLine = Array.isArray(node.lineAlarm) && node.lineAlarm.length; // b 线上

      let carNode = node.vehicle && node.vehicle.status === 1; // x 节点上
      let carLine = node.vehicle && node.vehicle.status === 2; // y 线上

      if (status === 0) {
        type = "0";
        return type;
      } else if (status === 1) {
        if (!abnNode && !abnLine && carLine) {
          type = "1y";
          return type;
        } else if (!abnNode && !abnLine && !(carNode || carLine)) {
          type = "1";
          return type;
        } else if (abnNode && !abnLine && !(carNode || carLine)) {
          type = "1a";
          return type;
        } else if (abnNode && !abnLine && carLine) {
          type = "1ay";
          return type;
        } else if (!abnNode && abnLine && !(carNode || carLine)) {
          type = "1b";
          return type;
        } else if (!abnNode && abnLine && carLine) {
          type = "1by";
          return type;
        } else if (abnNode && abnLine && !(carNode || carLine)) {
          type = "1ab";
          return type;
        } else if (abnNode && abnLine && carLine) {
          type = "1aby";
          return type;
        }
      } else if (status === 2) {
        if (!abnNode && !abnLine && !(carNode || carLine)) {
          type = "2";
          return type;
        } else if (!abnNode && !abnLine && carNode) {
          type = "2x";
          return type;
        } else if (abnNode && !abnLine && !(carNode || carLine)) {
          type = "2a";
          return type;
        } else if (abnNode && !abnLine && carNode) {
          type = "2ax";
          return type;
        }
      } else if (status === 3) {
        type = "3";
        return type;
      } else if (status === 4) {
        if (!abnNode && !abnLine && !(carNode || carLine)) {
          type = "4";
          return type;
        } else if (abnNode && !abnLine && !(carNode || carLine)) {
          type = "4a";
          return type;
        }
      }
    },

    // 格式化数据
    formartData() {
      this.localData = Object.freeze(
        this.data.map(item => {
          // 添加class
          item.class = `icon--${this.nodeIconClass(item)}`;

          // 处理温度
          item.temp =
            Array.isArray(item.temperature) &&
            item.temperature.reduce((total, cur) => {
              return (total += cur.name + "(" + cur.value + ") ");
            }, "");
          if (item.vehicle && Array.isArray(item.vehicle.temperature)) {
            item.vehicle.temp = item.vehicle.temperature.reduce(
              (total, cur) => {
                return (total += cur.name + "(" + cur.value + ") ");
              },
              ""
            );
          }
          // 处理车辆温度
          if (item.vehicle && typeof item.vehicle.speed === "number") {
            item.vehicle.speed += " km/h";
          }
          return item;
        })
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.waybill-axis .e6-axis .e6-axis-item .forward .temp {
  margin-top: 2px;
}
.line-top {
  position: absolute;
  right: -10px;
  top: 0px;
  font-size: 12px;
  color: #48494c;
}
</style>
